export default "__VITE_ASSET__B$xALCdc__"